import * as Sentry from '@sentry/react';
import { debug } from 'jssip';

import { formatSipLogMessage } from './sip-log-privacy';

export const SIP_DEBUG_STORAGE_KEY = 'hitphone:sipDebug';
let initialized = false;

const consoleEnabled = () => {
  try {
    return globalThis.localStorage?.getItem(SIP_DEBUG_STORAGE_KEY) === 'true';
  } catch {
    return false;
  }
};

export const initializeSipLogging = () => {
  if (initialized) return;
  initialized = true;

  // Initialize before Sentry wraps console so opt-in output isn't captured a
  // second time. Both destinations receive the same sanitized text below.
  const output = {
    debug: console.info.bind(console),
    warning: console.warn.bind(console),
    error: console.error.bind(console),
  };
  const originalFormatArgs = debug.formatArgs;

  // JsSIP assigns a bound console method to every logger, so debug.log alone
  // cannot redirect it. This typed debug hook runs before that method is used.
  debug.formatArgs = function (args: unknown[]) {
    if (this.namespace !== 'JsSIP' && !this.namespace.startsWith('JsSIP:')) {
      originalFormatArgs.call(this, args);
      return;
    }

    const level = this.namespace.startsWith('JsSIP:ERROR')
      ? 'error'
      : this.namespace.startsWith('JsSIP:WARN')
        ? 'warning'
        : 'debug';
    const message = `${this.namespace} ${formatSipLogMessage(args)} +${this.diff}ms`;
    args.splice(0, args.length, message);
    this.log = () => {
      try {
        Sentry.addBreadcrumb({ category: 'sip', level, message });
        if (level !== 'debug') Sentry.captureMessage(message, level);
      } catch {
        // Diagnostics must not interrupt SIP registration or calls.
      }
      if (consoleEnabled()) output[level](message);
    };
  };
};
